var global = require('../internals/global');
var isCallable = require('../internals/is-callable');

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-built-in.js
// module id = 29
// module chunks = 0